import { containsUrlParam } from './containsUrlParam';

export function isEmbeddedWebview({ location }: { location: Location }) {
  return containsUrlParam({ param: 'ewm', location });
}
